import store from '../store'
import ApiLoginCadastroIx from './ApiLoginCadastroIx'

export default {
  async getVinculoMeuIx () {
    const keycloak = new Keycloak('/keycloak/v22/keycloak.json')
    // define keycloak events
    keycloak.onAuthSuccess = () => {
      console.log('==> keycloak authenticated!')
      store.commit('set_idToken', keycloak.token)
      ApiLoginCadastroIx().defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`
    }

    keycloak.onReady = async (authenticated) => {
      console.log('==> keycloak initialized!')
      // caso a sessão no Keycloak tenha encerrado
      if (!authenticated) {
        // login
        await keycloak.init({
          redirectUri: location.href,
          checkLoginIframe: false,
          onLoad: 'login-required',
          pkceMethod: 'S256',
          flow: 'standard'
        })
      }
    }

    keycloak.onAuthError = (error) => {
      console.log('failed to initialize: ' + error)
    }

    keycloak.onTokenExpired = async () => {
      console.log('==> keycloak token expired!')
      if (!keycloak.authenticated) {
        await keycloak.init({
          redirectUri: location.href,
          checkLoginIframe: false,
          onLoad: 'login-required',
          pkceMethod: 'S256',
          flow: 'standard'
        })
      }
    }
    // start keycloak instance
    await keycloak.init(
      {
        pkceMethod: 'S256',
        onLoad: 'check-sso',
        silentCheckSsoFallback: false,
        silentCheckSsoRedirectUri: window.location.protocol + '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') + '/pagamento/keycloak/v22/check-sso.xhtml',
        flow: 'standard'
      }).catch(error => {
      console.log('==> failed to initialize: ' + error.error)
      return null
    })
    // get login info from ix-participantes api
    return ApiLoginCadastroIx().get().then(function (data) {
      data.data['token'] = keycloak.token
      return data
    }).catch(function (error) {
      console.log('Error', error)
    })
  }
}
